import { Grid, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import makeStyles from "@material-ui/core/styles/makeStyles";
import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import freeTrialImg from "../../assets/images/freeTrialImg.webp";
import { userJourneyContext } from "../../states/context/userJourneyContext";
import { getProgress } from "./mockUtils";
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { MockUserJourneyStates } from "./mockUserJourneyStates";
import { trackUserJourney } from "../../services/api.service";

const MockFreeTrial = () => {
  const history = useHistory();
  const userContext = useContext(userJourneyContext);
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [openAlert, setOpenAlert] = React.useState(false);
  const guided_tour = process.env.REACT_APP_GUIDED_TOUR;
  const calendly_url = process.env.REACT_APP_CALENDLY_URL;

  const makeApiCall = () => {
    (async () => {
      try {
        const userData = {...userContext.userJourneyInfo};
        userData.payload['send_auto_email_id'] = 7;
        userContext.setUserJourneyInfo(
          await updateUserJourneyState(userData)
        );
        userContext.setUserJourneyProgress(
          getProgress(userContext.userJourneyProgress)
        );
        return
      } catch (e) {
        console.log(e);
      }
    })();
  };

  const updateUserJourneyState = (currentState) => {
    (async () => {
      try {
        let currentStep = currentState.payload.steps;
        let stepInfoPayload = {title: MockUserJourneyStates[currentStep].stepTitle, steps: MockUserJourneyStates[currentStep].step, send_auto_email_id: 7};
        let payload = {...currentState, payload: stepInfoPayload};
       const _userJourney = currentState;
       _userJourney.payload = stepInfoPayload;
       await trackUserJourney(payload);
       history.push("/kavida/create-company");
       return _userJourney
        
      } catch (e) { 
        console.log(e);
      }
    })();
  };

  const getStarted = () => {
    setOpen(false);
    makeApiCall();
  };

  const handleClick = () => {
    setOpenAlert(true);
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenAlert(false);
  };

  return (
    <div>
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={open}
        BackdropProps={{
          classes: {
            root: classes.backDrop,
          },
        }}
      >
        <Grid container className={classes.modalRoot}>
          <Grid item xs={12}>
            <img
              src={freeTrialImg}
              style={{
                width: '100%',
                height: "192px",
              }}
              alt={"KAVIDA"}
              loading="lazy"
            />
          </Grid>
          <Grid item xs={12} className={classes.descriptionContainerStyle}>
            <Typography id="modal-title" className={classes.titleStyle}>
              Thank you for exploring Kavida!
            </Typography>
            <div className={classes.descriptionStyle}>
              <p>
                Thanks for taking the time to learn about how to get the most
                out of the Kavida platform.
              </p>
            </div>
            <div className={classes.descriptionStyle}>
              <p>
                If you enjoyed your experience, please share Kavida with
                your colleagues or have a chat with us to find out more.
              </p>
            </div>
            <div className={classes.descriptionStyle}>
              <p>
                Alternatively, if you wish to continue your experience we invite you to take a
                FREE 14 day trial in a practice PO environment to test out the features yourself
                with support from our team.
              </p>
            </div>
            <div className={classes.descriptionStyle}>
              <div>
                <Snackbar open={openAlert} autoHideDuration={2000} onClose={handleClose}>
                  <Alert onClose={handleClose} severity="success">
                    URL Copied
                  </Alert>
                </Snackbar>
              </div>
              <p >
                <u onClick={(e) => {
                  navigator.clipboard.writeText(guided_tour);
                  handleClick(e);
                }}>Share Kavida with just a link</u>
              </p>
            </div>
            <div className={classes.descriptionStyle}>
              <div>
              </div>
              <p>
                <u
                  onClick={(e) => {
                    window.open(calendly_url, '_blank');
                  }}
                  style={{ cursor: "pointer" }}>
                  Arrange a call with a solutions engineer
                </u>
              </p>
            </div>
          </Grid>
          <Grid item xs={12} className={classes.buttonContainerStyle}>
            <Button
              className={classes.buttonStyle}
              variant="contained"
              onClick={() => getStarted()}
            >
              Start 14 day free trial
            </Button>
            <span className={classes.spanTextStyle}>No credit cards or payments required</span>
          </Grid>
        </Grid>
      </Dialog>
    </div>
  );
};

export default MockFreeTrial;

const useStyles = makeStyles((theme) => ({
  modalRoot: {
    width: "440px",
    height: "650px",
    overflow: 'hidden',
    "& .MuiButton-root": {
      backgroundColor: "#3B82F6",
      color: "white",
      textTransform: "none",
      borderRadius: "2px",
    },
  },
  modalRootKeyPointersStyle: {
    width: "440px",
    height: "464px",
    "& .MuiButton-root": {
      backgroundColor: "#3B82F6",
      color: "white",
      textTransform: "none",
      borderRadius: "2px",
    },
  },
  descriptionContainerStyle: {
    padding: "24px",
    paddingBottom: "0px",
  },
  titleStyle: {
    fontFamily: "Inter",
    fontWeight: 700,
    fontSize: "18px",
    lineHeight: "28px",
  },
  descriptionStyle: {
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#64748B",
  },
  buttonStyle: {
    marginLeft: "20px",
  },
  buttonContainerStyle: {
    backgroundColor: "#F8FAFC",
    marginBottom: "10px"
  },
  backDrop: {
    backdropFilter: "blur(8px)",
    backgroundColor: "rgba(255,255,255,0.01)",
  },
  spanTextStyle: {
    fontFamily: "Inter",
    fontSize: "12px",
    marginLeft: "10px",
    color: "#64748B",
  }
}));
